import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AnalyticEvent, AnalyticsBloc } from '@kanalytics';
import { NavigationBloc, SharingBloc, TagBloc } from '@kbloc';
import { EnvironmentVariablesService } from '@kenv';
import { UserBloc } from '@kp/user/user.bloc';
import { DataStoreService } from '@kservice';
import { AppSwitchLocation } from '@ktypes/enums';
import { NavItemType, ProductInfo } from '@ktypes/models';

@Component({
  selector: 'kp-site-nav',
  templateUrl: './site-nav.component.html',
  styleUrls: ['./site-nav.component.scss'],
})
export class SiteNavComponent implements OnInit {
  @Input() navActive: boolean;
  @Output() sidebarClick = new EventEmitter<boolean>();

  navType = NavItemType;

  constructor(
    private _analyticsBloc: AnalyticsBloc,
    public dataStore: DataStoreService,
    private _environmentVariablesService: EnvironmentVariablesService,
    public navBloc: NavigationBloc,
    private _router: Router,
    public sharingBloc: SharingBloc,
    public tagBloc: TagBloc,
    private _userBloc: UserBloc
  ) {}

  ngOnInit() {
    this.routeEvent(this._router);
  }

  routeEvent(router: Router) {
    router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        this.sidebarClick.emit(true);
      }
    });
  }

  onSidebarClick(e: MouseEvent) {
    const element = e.target as HTMLElement;
    if (element.tagName !== 'A' && !element.closest('a')) {
      this.sidebarClick.emit();
      e.preventDefault();
    }
  }

  closeOverlay() {
    this.sidebarClick.emit();
  }

  trackEvent(app: ProductInfo) {
    const event = this._analyticsBloc.createEventFromInteraction({
      event: AnalyticEvent.app_switch_requested,
      meta: {
        app_requested: app.product,
        link_location: AppSwitchLocation.menu,
        source_app: this._environmentVariablesService.product,
      },
    });
    this._analyticsBloc.sendEvent(event);
    this._userBloc.switchApplication(app.product);
    this.closeOverlay();
  }
}
